import { render, staticRenderFns } from "./epb-card.component.vue?vue&type=template&id=4fb74498&scoped=true"
import script from "./epb-card.component.vue?vue&type=script&lang=ts"
export * from "./epb-card.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-card.component.vue?vue&type=style&index=0&id=4fb74498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb74498",
  null
  
)

export default component.exports